/* HitchFire — In the Wild (SocialPhotos) reveal-if-photos controller.
   The section renders hidden (.in-wild--app.is-empty) on product pages that rely
   on the SocialPhotos app. This shows it only once the widget injects real photos;
   if none load, the whole section stays hidden. Loaded as an external asset so the
   Visually.io (vsly) A/B script can't mangle it. */
(function () {
  function init() {
    var sec = document.getElementById('in-the-wild');
    if (!sec || sec.getAttribute('data-inwild-mode') !== 'app') return;
    var gal = sec.querySelector('.socialphotos-com-gallery');
    if (!gal) return;
    var done = false;
    function hasPhotos() {
      return !!gal.querySelector('img') || gal.children.length > 0;
    }
    function reveal() {
      if (done) return;
      if (hasPhotos()) {
        done = true;
        sec.classList.remove('is-empty');
        if (obs) obs.disconnect();
      }
    }
    var obs = new MutationObserver(reveal);
    obs.observe(gal, { childList: true, subtree: true });
    reveal();
    // Give the app time to load; if still empty afterward, leave the section hidden.
    setTimeout(function () { if (obs) obs.disconnect(); }, 10000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
